import React, { FC } from 'react';
import { useTranslation } from 'next-i18next';
import { PATHS } from 'src/common/constants';
import styles from './Legal.module.scss';
import Icon from '../IconDS22';
import UniversalLink from '../UniversalLink';

const Legal: FC = () => {
  const [t] = useTranslation('common');
  return (
    <div className={styles.root}>
      <div className={styles.copyrightNotice}>
        <Icon id="getmyboat" className={styles.icon} size="xl" />
        <span className={styles.copyrightText}>{t('copyright', { year: new Date().getFullYear() })}</span>
      </div>
      <UniversalLink href={PATHS.TERMS} className={styles.link}>
        {t('terms-link')}
      </UniversalLink>
      <UniversalLink href={PATHS.PRIVACY_POLICY} className={styles.link}>
        {t('privacy-link')}
      </UniversalLink>
    </div>
  );
};

export default Legal;
